export default __webpack_public_path__ + "static/media/we_work_with_the_best_bg.e17ce4e7.png";